/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ClientInputs */

const de__field_client = /** @type {(inputs: _Field_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kund:in`)
};

/**

* @param {_Field_ClientInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_client = /** @type {((inputs?: _Field_ClientInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ClientInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_client(inputs)
});